import { css } from '@emotion/react'

export default css`
    .ant-card {
        background-color: #2d2932;
    }

    .export .ant-card {
        background-color: #ffffff;
    }
`
